import { RejectChanges } from 'almanac-ui/icons/24'
import cx from 'classnames'
import { Button } from 'components/Button'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import Styles from './TrackChangesButtons.module.scss'

const RejectAllButton = observer(() => {
  const docStore = useDocStore()
  const { rejectAll, changesCount, canRejectChanges } = docStore.trackedChangesStore
  const isDisabled = !canRejectChanges || !changesCount

  return (
    <Button
      size="md"
      isDisabled={isDisabled}
      onPress={rejectAll}
      variant="tertiary"
      frontIcon={RejectChanges}
      iconClassName={cx(Styles.icon, Styles.doubleClassOverride)}
      className={cx(Styles.button, Styles.doubleClassOverride)}
    >
      Reject all changes
    </Button>
  )
})

export { RejectAllButton }
